import { FC } from "react"
import { FACILITY_TIMEZONES } from "./constants"
import TextField from "./TextField"
import Autocomplete, {
   AutocompleteOption,
} from "@/components/shared/Autocomplete"
import { FacilityAddress } from "@/types/facility"

type Timezone = FacilityAddress["timezone"]

interface TimezoneCellProps {
   value: Timezone
   isEditMode: boolean
   onChange: (timezone: Timezone) => void
}

const DEVICE_DEFAULT_LABEL = "Device default time zone"

const getTimezoneLabel = (timezone: Timezone): string =>
   timezone ?? DEVICE_DEFAULT_LABEL

const TIMEZONE_OPTIONS: AutocompleteOption<Timezone>[] = [
   null,
   ...FACILITY_TIMEZONES,
].map((timezone) => ({ label: getTimezoneLabel(timezone), value: timezone }))

const getTimezoneOptions = (
   value: Timezone
): AutocompleteOption<Timezone>[] => {
   const isListed = TIMEZONE_OPTIONS.some((option) => option.value === value)
   if (isListed) return TIMEZONE_OPTIONS

   return [...TIMEZONE_OPTIONS, { label: getTimezoneLabel(value), value }]
}

const TimezoneCell: FC<TimezoneCellProps> = ({
   value,
   isEditMode,
   onChange,
}) => {
   if (!isEditMode) {
      return <TextField name="timezone">{getTimezoneLabel(value)}</TextField>
   }

   return (
      <Autocomplete
         options={getTimezoneOptions(value)}
         value={value}
         onChange={onChange}
      />
   )
}

export default TimezoneCell
